import { useLayoutEffect, useState } from 'react';

const calcDuration = (marquee: HTMLDivElement, speedPxPerSec: number) => {
  const container = marquee;

  const totalWidth = Array.from(container.children).reduce((acc, child) => {
    const width = (child as HTMLElement).offsetWidth || 0;
    return acc + width;
  }, 0);

  return totalWidth / speedPxPerSec;
};
export const useMarqueeDuration = (
  marquee: HTMLDivElement,
  speedPxPerSec: number,
) => {
  const [duration, setDuration] = useState(
    marquee ? calcDuration(marquee, speedPxPerSec) : 0,
  );
  useLayoutEffect(() => {
    if (!marquee) return;
    setDuration(calcDuration(marquee, speedPxPerSec));
  }, [marquee]);
  return duration;
};